import { SET_LEADS, SET_LEADS_LIST, SET_TEMPLATES, SET_NUMBERS, SET_CURRENT_NUMBER, SET_PAYMENT_INFO, CLEAR_LEADS } from './kaiziqLeadsTypes';

export const setLeads = (leads)=> ({
    type: SET_LEADS,
    payload: leads
});

export const setLeadsList = (leadsList)=> ({
    type: SET_LEADS_LIST,
    payload: leadsList
});

export const setTemplateList = (templateList) => ({
    type: SET_TEMPLATES,
    payload: templateList
});

export const setNumbersList = (numbersList) => ({
    type: SET_NUMBERS,
    payload: numbersList
});

export const setCurrentPhoneNumber = (currentPhoneNumber) => ({
    type: SET_CURRENT_NUMBER,
    payload: currentPhoneNumber
});

export const setPaymentInfo = (paymentInfo) => ({
    type: SET_PAYMENT_INFO,
    payload: paymentInfo
});

export const clearLeads = () => ({
    type: CLEAR_LEADS
});